import React from 'react'
import styled from 'styled-components'
import { Buildings, CurrencyDollar, CalendarCheck, UsersThree } from 'phosphor-react'
import { useCrmSummary } from 'hooks/crm'
import { formatMoney, formatMoneyShort } from 'utility/crm/dates'
import { Card } from './ui'

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    @media (max-width: 992px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`

const Tile = styled(Card)`
    display: flex;
    gap: 12px;
    align-items: center;
    .value {
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 1.1;
    }
    .label {
        opacity: 0.7;
        font-size: 0.8rem;
    }
    .sub {
        opacity: 0.7;
        font-size: 0.8rem;
    }
    .sub .bad {
        color: #dc2626;
        font-weight: 600;
    }
`

export const KpiTiles = () => {
    const { data, error, loading, refetch } = useCrmSummary()

    if (error && !data) {
        return (
            <Card role="alert">
                {error.message}{' '}
                <button type="button" className="ui mini button" onClick={refetch}>
                    Try again
                </button>
            </Card>
        )
    }

    const s = data
    const dash = loading && !s ? '–' : null
    const due = s ? s.FollowupsOverdue + s.FollowupsToday : 0

    return (
        <Grid aria-label="CRM summary" aria-busy={loading}>
            <Tile>
                <UsersThree size={28} aria-hidden="true" />
                <div>
                    <div className="label">Contacts</div>
                    <div className="value">{dash ?? s.Contacts}</div>
                    <div className="sub">{s ? `${s.Prospects} prospects` : ''}</div>
                </div>
            </Tile>
            <Tile>
                <Buildings size={28} aria-hidden="true" />
                <div>
                    <div className="label">Customer accounts</div>
                    <div className="value">{dash ?? s.CustomerAccounts}</div>
                    <div className="sub">{s ? `of ${s.Accounts} accounts` : ''}</div>
                </div>
            </Tile>
            <Tile>
                <CurrencyDollar size={28} aria-hidden="true" />
                <div>
                    <div className="label">Open pipeline</div>
                    <div className="value">{dash ?? formatMoneyShort(s.OpenPipelineAmount)}</div>
                    <div className="sub">
                        {s ? `${s.OpenDealCount} deals · ${formatMoney(s.WeightedAmount)} weighted` : ''}
                    </div>
                </div>
            </Tile>
            <Tile>
                <CalendarCheck size={28} aria-hidden="true" />
                <div>
                    <div className="label">Follow-ups due</div>
                    <div className="value">{dash ?? due}</div>
                    <div className="sub">
                        {s ? (
                            <>
                                <span className={s.FollowupsOverdue ? 'bad' : ''}>{s.FollowupsOverdue} overdue</span>
                                {` · ${s.FollowupsToday} today`}
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </Tile>
        </Grid>
    )
}
